export default function handlePayPal(transactionDetails) {
  const approveLink = transactionDetails.links.filter((item) => item.rel === 'payer-action')
  if (approveLink.length > 0) {
    window.location = approveLink[0].href
  }
}
